import React, { useState, useEffect } from 'react'
import Header from 'components/Headers/Header';
import { Button, Col, Row, Container, Card, CardHeader, CardBody, Spinner, CardFooter } from 'reactstrap';
import { useParams, useNavigate, Link  } from 'react-router-dom';
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import axios from 'axios'

function DeleteFieldActivities() {
  
  const [loading, setLoading] = useState(true)
  const [loadingsubmit, setLoadingsubmit] = useState(true)

  const [fieldactivity, setFieldactivity] = useState([])

  const token = useSelector((state) => state.userLogin.userInfo.token);

  const { fieldId } = useParams()
  const navigate = useNavigate()

  // i18n
  const { t, i18n } = useTranslation(); 

  useEffect(() => {
      const storedLanguage = localStorage.getItem('selectedLanguageAFS');
      if (storedLanguage) {
      i18n.changeLanguage(storedLanguage);
      }
  }, [i18n]);

  useEffect(() => {

    const fetchData = async () => {
      
      try {

        const config = {
          headers: {
              'Content-type': 'application/json',
              Authorization: `Bearer ${token}`
          }
        }

        const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/company-management/field-activity/${fieldId}/`, config);
        console.log(response)
        setFieldactivity(response.data)
       
      } catch (error) {

      } finally {
        setLoading(false)
      }

    };

    fetchData();
  }, [fieldId, token]);

  const submit = async () => {

    setLoadingsubmit(false)
    
    try {

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        }

        await axios.delete(`${process.env.REACT_APP_BACKEND_API}/company-management/delete-field-activity/${fieldId}/`, config);

    } catch (error) {
        console.error(`Error deleting field with ID ${fieldId}:`, error);
    } finally {
        setLoadingsubmit(true)
        navigate('/field-activity/');
    }
  };

  return (
    <div>
      <Header/>
      {loading ? (
          <>
            <Container className="mt--15" fluid>
              <Row>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                  <Spinner>
                    {t('Loading')}
                  </Spinner>
                </Col>
              </Row>
            </Container>
          </>
      ):(
        <>
          <Container className="mt--15" fluid>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                <Card>
                  <CardHeader>
                    <h3>{t('Are you sure to delete this field activity?')}</h3>
                  </CardHeader>
                  <CardBody>
                    <br></br>
                    <h3>{t('Field Activity')}</h3>
                    <ul>
                        <li>{t('Date')} {" "} {fieldactivity.DateFieldActivity}</li>
                        <li>{t('Farm')} {" "} {fieldactivity.FarmerName}</li>
                        <li>{t('Field')} {" "} {fieldactivity.FieldName}</li>
                        <li>{t('Operator')} {" "} {fieldactivity.OperatorName}</li>
                        <li>{t('Type')} {" "} {fieldactivity.FieldActivity}</li>
                        <li>{t('Crop')} {" "} {fieldactivity.Crop}</li>
                        <li>{t('Crop Phenology')} {" "} {fieldactivity.CropPhenology}</li>
                        <li>{t('Total Cost')} {" "} {fieldactivity.TotalCost}</li>
                    </ul>
                  </CardBody>
                  <CardFooter>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="d-flex justify-content-center">
                      {loadingsubmit ? (
                        <>
                          <Button color="danger" onClick={submit}>
                            {t('Delete Field Activity')} <i className="fas fa-trash"></i>
                          </Button>
                        </>
                        ) : (
                        <>
                        <Button color="danger" disabled>
                          <Spinner size="sm">
                            {t('Deleting the Field Activity...')}
                          </Spinner>
                          <span>
                            {' '}{t('Deleting the Field Activity...')}
                          </span>
                        </Button>
                        </>
                        )
                      }
                      <div className="mx-2"></div>
                      <Link to="/field-activity/">
                        <Button color="primary">
                          {t('Go back')} <i className="fas fa-rotate-left"></i>
                        </Button>
                      </Link>                                           
                    </Col>
                  </CardFooter>
                </Card>
              </Col>
            </Row>
          </Container>
        </>
      )}
    </div>
  )
}

export default DeleteFieldActivities
